// extracted by mini-css-extract-plugin
module.exports = {"root":"SalesBlade-module--root--21XqP","textColumn":"SalesBlade-module--textColumn--3jaB2"};